import { Global } from "@emotion/react";

import * as styles from "./App.styles";


export default function GlobalStyles() {

  return (
    <>
      <Global styles={styles.fonts} />
      <Global styles={styles.reset} />
      <Global styles={styles.site} />
      <Global styles={styles.base} />
    </>
  );
}
